import classNames from 'classnames';

import React, {
  createContext,
  forwardRef,
  ForwardRefExoticComponent,
  HTMLAttributes,
  RefAttributes,
  useState,
} from 'react';

import styles from './radio-group.scss';

type Props = RefAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    disabled?: boolean;
    onChange: (value: string) => void;
    children?: React.ReactNode;
    dataTestId?: string;
  };

const COMPONENT_ID = 'modulor-radio-group';

export const RadioGroupContext = createContext<{
  disabled: boolean;
  checkedValue: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
} | null>(null);

export const RadioGroup: ForwardRefExoticComponent<Props> = forwardRef<HTMLInputElement, Props>(
  ({ disabled, onChange, children, className, ...rest }, ref, dataTestId = COMPONENT_ID) => {
    const [checkedValue, setCheckedValue] = useState<string | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setCheckedValue(e.target.value);
      onChange(e.target.value);
    };

    return (
      <RadioGroupContext.Provider value={{ disabled, checkedValue, handleChange }}>
        <div
          data-testid={dataTestId}
          data-id={dataTestId}
          data-component-name={COMPONENT_ID}
          ref={ref}
          className={classNames(className, styles['radio-group'])}
          {...rest}>
          {children}
        </div>
      </RadioGroupContext.Provider>
    );
  },
);

RadioGroup.displayName = 'RadioGroup';
